<template>
  <v-container fluid class="gym-subscription-check-in-record-list">
    <v-data-table :items="records"
                  :headers="recordHeaders"
                  fixed-header
                  class="remote-paginated-list--table">
      <template v-slot:item.checkin_time="{value}">
        {{ fromISO(value).toFormat('yyyy-MM-dd HH:mm:ss') }}
      </template>
      <template v-slot:item.checkout_time="{value}">
        {{ value ? fromISO(value).toFormat('yyyy-MM-dd HH:mm:ss') : '' }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {ref, watch} from '@vue/composition-api'
import {DateTime} from 'luxon'

export default {
  name: 'GymSubscriptionCheckInRecordList',
  props: {
    subscriptionId: String,
    fromDate: String,
    toDate: String,
    isAdmin: Boolean,
  },
  setup(props, {root}) {
    const records = ref([]);
    const recordHeaders = ref([
      {text: root.$t('gym_subscription.checkin_time'), value: 'checkin_time'},
      {text: root.$t('gym_subscription.checkout_time'), value: 'checkout_time'},
      {text: root.$t('gym_subscription.type'), value: 'subscription.type.name'},
    ]);

    const getRecords = function () {
      let url = props.isAdmin ? 'aafb/admin/gym_subscription/checkin_record/' : 'aafb/gym_subscription/checkin_record/';

      root.$callAPI(url, {
        subscription_id: props.subscriptionId,
        from_date: props.fromDate,
        to_date: props.toDate,
      }, function (response) {
        records.value = response.body.records;
      });
    };

    watch([props.subscriptionId, props.fromDate, props.toDate], () => {
      getRecords();
    }, {immediate: true});

    return {
      records,
      recordHeaders,
      fromISO: DateTime.fromISO,
    }
  }
}
</script>

<style lang="less">
.gym-subscription-check-in-record-list {
  display: flex;
  flex-direction: column;
  height: 100%;

  .remote-paginated-list--table {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;

    .v-data-table__wrapper {
      flex: 1 1 0;
      overflow-y: auto;
    }

    .v-data-footer {
      margin-right: 0 !important;
    }
  }
}
</style>
